import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_TOKEN_KEY = "loadtms_session_token";
const nativeFetch = window.fetch.bind(window);

// Cloudflare Pages and Render are on different sites. Attach the
// authenticated session as a Bearer token to backend API requests.
window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url;
  const token = window.localStorage.getItem(SESSION_TOKEN_KEY);

  if (token && API_URL && url?.startsWith(API_URL)) {
    const existingHeaders =
      init.headers || (input instanceof Request ? input.headers : undefined);
    const headers = new Headers(existingHeaders);

    if (!headers.has("Authorization")) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    init = { ...init, headers };
  }

  return nativeFetch(input, init);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);